<template>
  <table width="100%" border="0" cellspacing="0" cellpadding="0">
    <tbody><tr>
      <td height="30" colspan="4">
        <div align="center"><img src="https://static.gabia.com/mail/common/hosting_quo.gif" width="77" height="22" alt="견적서"></div>
      </td>
    </tr>
    <tr valign="top">
      <td height="40" colspan="4">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody><tr>
            <td height="10"></td>
          </tr>
          </tbody></table>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="estimate_info">
          <tbody><tr height="30">
            <td width="10%">날&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;짜</td>
            <td width="40%">: {{today}} </td>
            <td width="10%">상&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;호</td>
            <td width="40%" colspan="2">: (주)가비아</td>
          </tr>
          <tr height="30">
            <td width="10%">수&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;신</td>
            <td width="40%" v-show="!printMode">:   <label><input type="text" v-model="receiver" class="i_text" style="width: 200px;"> </label></td>
            <td width="40%" v-show="printMode" @mouseover="changePrintMode">:   {{receiver}} </td>
            <td width="10%">등 록 번 호</td>
            <td width="40%" colspan="2">: 214-86-39239</td>
          </tr>
          <tr height="30">
            <td width="10%">유 효 기 간</td>
            <td width="40%"><span>: 견적일 당일</span></td>
            <td width="10%" valign="top">주&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;소</td>
            <td width="40%" colspan="2">: 경기도 성남시 분당구 대왕판교로 660(삼평동)<br>&nbsp;   유스페이스1 B동 4층   </td>
          </tr>
          <tr height="30">
            <td width="10%">지 불 조 건</td>
            <td width="40%">: 전액 선납</td>
            <td width="10%">전화번호</td>
            <td width="25%">: 1544-4370</td>
            <td width="15%" rowspan="2" valign="bottom"><img src="https://static.gabia.com/mail/common/seal.gif" alt="" width="49" height="51" border="0"></td>
          </tr>
          <tr height="30">
            <td width="10%"></td>
            <td width="40%"></td>
            <td width="10%">대&nbsp;표&nbsp;자</td>
            <td width="25%">: 김홍국</td>
          </tr>
          </tbody></table>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody><tr>
            <td height="10"></td>
          </tr>
          </tbody></table>
      </td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "CompanyInfo",
  props:{
    printMode: {
      type: Boolean,
      required: true,
    },
  },
  data(){
    return {
      receiver: null,
    }
  },
  computed: {
    today(){
      const today = new Date();

      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const date = today.getDate()
      
      return year + "년 "+ month + "월 " + date +"일"
    }
  },

  methods: {
    changePrintMode(){
      this.$emit('change-print-mode')
    }
  }
}
</script>

<style scoped>

</style>